const mapStateToProps = (state) => ({
  step: state.citaDeEmpadronamiento.step,
});

export default mapStateToProps;
